const formatList = [
	{ value: '', label: '', },
	{ value: 'CUSTOM', label: 'Custom', },
	{ value: 'OVERLAY', label: 'Overlay' },
	{ value: 'HEADERBAR', label: 'Header bar' },
	{ value: 'INAPP', label: 'In Page' },
];

export default formatList;